var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ban-modal wrapper" },
    [
      _vm.internalBanModalVisible
        ? _c(
            "Modal2",
            {
              staticClass: "ban-modal",
              attrs: {
                "show-footer": false,
                title: _vm.$t("message.banModalTitle"),
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("table", { staticClass: "ban-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.platform")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("chatbotv2.value")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.sendingAllow")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.receiving")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", { staticClass: "visitor-row" }, [
                    _c("td", { staticClass: "icon-cell" }, [
                      _c("img", {
                        staticClass: "ban-modal-icon supsis-logo",
                        class: { disable: !_vm.visitor._id },
                        attrs: {
                          src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.visitor._id))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "web-visitor",
                              "outbound"
                            ),
                            disabled: !_vm.visitor._id,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "web-visitor",
                                "outbound",
                                _vm.visitor._id,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "web-visitor",
                              "inbound"
                            ),
                            disabled: !_vm.visitor._id,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "web-visitor",
                                "inbound",
                                _vm.visitor._id,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "whatsapp-row" }, [
                    _c(
                      "td",
                      { staticClass: "icon-cell" },
                      [
                        _c("whatsappIcon", {
                          staticClass: "ban-modal-icon",
                          class: { disable: !_vm.visitor.whatsappNumber },
                          attrs: { color: "#25D366" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.visitor.whatsappNumber ||
                            _vm.$t("visitor.noWpNumber")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "whatsapp",
                              "outbound"
                            ),
                            disabled: !_vm.visitor.whatsappNumber,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "whatsapp",
                                "outbound",
                                _vm.visitor.whatsappNumber,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "whatsapp",
                              "inbound"
                            ),
                            disabled: !_vm.visitor.whatsappNumber,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "whatsapp",
                                "inbound",
                                _vm.visitor.whatsappNumber,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "instagram-row" }, [
                    _c(
                      "td",
                      { staticClass: "icon-cell" },
                      [
                        _c("PlatformIcon", {
                          attrs: { platform: "instagram", size: 40 },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.visitor.instagramUserId || "No Detail")
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "instagram",
                              "outbound"
                            ),
                            disabled: !_vm.visitor.instagramUserId,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "instagram",
                                "outbound",
                                _vm.visitor.instagramUserId,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "instagram",
                              "inbound"
                            ),
                            disabled: !_vm.visitor.instagramUserId,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "instagram",
                                "inbound",
                                _vm.visitor.instagramUserId,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "messenger-row" }, [
                    _c(
                      "td",
                      { staticClass: "icon-cell" },
                      [
                        _c("PlatformIcon", {
                          attrs: { platform: "messenger", size: 40 },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.visitor.messengerUserId || "No Detail")
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "messenger",
                              "outbound"
                            ),
                            disabled: !_vm.visitor.messengerUserId,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "messenger",
                                "outbound",
                                _vm.visitor.messengerUserId,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "messenger",
                              "inbound"
                            ),
                            disabled: !_vm.visitor.messengerUserId,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "messenger",
                                "inbound",
                                _vm.visitor.messengerUserId,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "mail-row" }, [
                    _c(
                      "td",
                      { staticClass: "icon-cell" },
                      [
                        _c("gmail-icon", {
                          staticClass: "ban-modal-icon",
                          class: { disable: !_vm.visitor.email },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.visitor.email || _vm.$t("visitor.noEmail"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "email",
                              "outbound"
                            ),
                            disabled: !_vm.visitor.email,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "email",
                                "outbound",
                                _vm.visitor.email,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("a-switch", {
                          staticClass: "ml-2 mr-2 switch",
                          attrs: {
                            "un-checked-children": "✔",
                            "checked-children": "✖",
                            checked: _vm.getVisitorSuppression(
                              "email",
                              "inbound"
                            ),
                            disabled: !_vm.visitor.email,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setVisitorSuppression(
                                "email",
                                "inbound",
                                _vm.visitor.email,
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }